import { render, staticRenderFns } from "./who-pays-title.vue?vue&type=template&id=67590d30"
import script from "./who-pays-title.vue?vue&type=script&lang=js"
export * from "./who-pays-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports